class WaitTimer {
    constructor(name, timeOut) {
        this.name = name + '.timer';
        this.timeOut = timeOut * 1000;
        this.lastFetchTime = this.getLastFetchTime();
    }
    resetLastFetchTime() {
        this.lastFetchTime = Date.now();
        localStorage.setItem(this.name, this.lastFetchTime.toString());
    }
    setLastFetchTime(time) {
        this.lastFetchTime = time;
        localStorage.setItem(this.name, this.lastFetchTime.toString());
    }
    getLastFetchTime() {
        const storedTime = localStorage.getItem(this.name);
        return storedTime ? parseInt(storedTime) : null;
    }
    isTimeExpired(expiryTime) {
        if (!this.lastFetchTime) {
            return true;
        }
        const currentTime = Date.now();
        return (currentTime - this.lastFetchTime) > expiryTime;
    }
}
export default WaitTimer;